import { loginByUsername, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    userdata: {},
    token: getToken(),
    unReadCount: 0
  },

  mutations: {
    SET_USERDATA: (state, userdata) => {
      state.userdata = userdata
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    CHANGE_UNREAD_COUNT: (state, count) => {
      state.unReadCount = count
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await loginByUsername(username, userInfo.password)
          commit('SET_TOKEN', data.access_token)
          setToken(data.access_token)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await getUserInfo()
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('error')
          }
          const data = response.data
          // 只有 type: "4" 才能登陆成功；
          // 如果第一次不是type: "4" 就再请求一次，如果还不是4就提示：系统登录繁忙，请稍后再试！
          // 刷新的时候也一样，第二次请求的结果不是4就直接退出到登录界面。
          // 官网前端与产品确认，所有人都能登录这里不做限制
          if (data.type === '4' || data.type === '5' || !window.location.href.includes('backstage')) {
            commit('SET_USERDATA', data)
            commit('SET_AVATAR', process.env.BASE_IMAGE_URL + data.photo)
            resolve(response)
          } else {
            const res = await getUserInfo()
            if (res.data.type === '4' || res.data.type === '5') {
              commit('SET_USERDATA', res.data)
              commit('SET_AVATAR', process.env.BASE_IMAGE_URL + res.data.photo)
              resolve(res)
            } else {
              reject(state)
            }
          }
        } catch (error) {
          reject(error)
        }
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          await logout(state.token)
          commit('SET_TOKEN', '')
          commit('SET_USERDATA', {})
          commit('SET_AVATAR', '')
          removeToken()
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USERDATA', {})
        commit('SET_AVATAR', '')
        removeToken()
        resolve()
      })
    },

    changeUnReadCount({ commit }, count) {
      commit('CHANGE_UNREAD_COUNT', count)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
      setToken(token)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js